import { forwardRef } from 'react';
import Button from '../Button';

interface CounterProps {
  value?: number;
  min?: number;
  max?: number;
  step?: number;
  onChange?: (value: number) => void;
  className?: string;
  name?: string;
}

export const Counter = forwardRef<HTMLInputElement, CounterProps>(
  ({ value = 1, min = 1, max = 99, step = 1, onChange, className = '', name }, ref) => {
    
    const handleIncrement = () => {
      const newValue = Math.min((value ?? min) + step, max);
      onChange?.(newValue);
    };

    const handleDecrement = () => {
      const newValue = Math.max((value ?? min) - step, min);
      onChange?.(newValue);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const numValue = parseInt(e.target.value) || min;
      const clampedValue = Math.min(Math.max(numValue, min), max);
      onChange?.(clampedValue);
    };

    return (
      <div className={`flex rounded-md overflow-hidden ${className}`}>
        <Button
          onClick={handleDecrement}
          style='outline'
          // className='border-none'
          disabled={value <= min}
          className="border-solid !w-[25px] !h-[25px] flex items-center justify-center hover:bg-gray-200 !p-0 !border-[#232323] !border-[1px] !text-[#232323] "
        >
          -
        </Button>
        
        <input
          ref={ref}
          // type="number"
          name={name}
          value={value}
          onChange={handleChange}
          min={min}
          max={max}
          step={step}
          className="w-[35px] text-center self-start text-[20px] font-semibold leading-[100%] tracking-[-2%]  focus:outline-none  focus:ring-transparent"
        />
        
        <Button
          onClick={handleIncrement}
          style='outline'
          className="border-solid !w-[25px] !h-[25px] flex items-center justify-center !p-0 !border-[#232323] !border-[1px] !text-[#232323] hover:bg-gray-200"
          disabled={value >= max}
        //   className="px-3 py-1 bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
        >
          +
        </Button>
      </div>
    );
  }
);

export default Counter;